<script>
  import DatePicker from '../DatePicker/Datepicker.svelte'
  import { faCalendar } from '@fortawesome/pro-regular-svg-icons'

  import { getContext, tick } from 'svelte'
  import writableDerived from 'svelte-writable-derived'

  import Icon from '../Icon/'
  import { extractDate } from '../FormElements/timeHelpers.js'
  import { cssPrefix } from '../helper-classes.js'

  import dayjs from 'dayjs'
  import customParseFormat from 'dayjs/plugin/customParseFormat'
  dayjs.extend(customParseFormat)

  // export let elementName
  export let variant = null
  export let config = {}
  export let id = null

  const element = getContext('currentElement')

  let delegate
  const minDate = [undefined, undefined]
  const maxDate = [undefined, undefined]
  const selected = [new Date(), new Date()]

  const pickerFormat = 'D/M/YYYY'

  if (variant !== 'Native') {
    config.textType = true

    delegate = writableDerived(
      element,
      state => {
        const extracted0 = extractDate(state.value[0], 'YYYY-MM-DD')
        const extracted1 = extractDate(state.value[1], 'YYYY-MM-DD')
        if (extracted0.date) selected[0] = extracted0.date
        if (extracted1.date) selected[1] = extracted1.date
        return [extracted0, extracted1]
      },
      (reflecting, old) => {
        return {
          ...old,
          value: [
            reflecting[0].success ? reflecting[0].iso : old.value[0],
            reflecting[1].success ? reflecting[1].iso : old.value[1]
          ]
        }
      }
    )

    if (Array.isArray($element.min) && $element.min.length === 2) {
      const extracted0 = extractDate($element.min[0], 'YYYY-MM-DD')
      const extracted1 = extractDate($element.min[1], 'YYYY-MM-DD')
      if (extracted0.success) minDate[0] = extracted0.date
      if (extracted1.success) minDate[1] = extracted1.date
    }
    if (Array.isArray($element.max) && $element.max.length === 2) {
      const extracted0 = extractDate($element.max[0], 'YYYY-MM-DD')
      const extracted1 = extractDate($element.max[1], 'YYYY-MM-DD')
      if (extracted0.success) maxDate[0] = extracted0.date
      if (extracted1.success) maxDate[1] = extracted1.date
    }
  }

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal', 'has-control']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  {#if $element.label}
    <div class={`${cssPrefix}form-label`}>
      <div class={`${cssPrefix}label`} class:is-required={$element.required && !$element.disabled}>
        <label for={id[0]}>{$element.label}</label>
      </div>
    </div>
  {/if}

  <div class={`${cssPrefix}form-field`}>
    <div class={`${cssPrefix}controls is-grouped`}>
      <div class={`${cssPrefix}control`}>
        <label for="from" class={`${cssPrefix}label`}>From</label>
      </div>

      {#if variant === 'Native'}
        <div class={`${cssPrefix}control`}>
          <slot name="from" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
        </div>
      {:else}
        <div class={`${cssPrefix}control is-date ${cssPrefix}date-picker has-icons-end`}>
          <DatePicker
            start={minDate[0]}
            end={maxDate[0]}
            format={pickerFormat}
            bind:selected={selected[0]}
            bind:dateChosen={$delegate[0].success}
            bind:formattedSelected={$delegate[0].iso}
            on:open={() => element.onEvent(new Event('focus'))}
            on:close={() => element.onEvent(new Event('blur'))}
            on:change={() => tick().then(() => element.onEvent(new Event('change')))}
          >
            <slot name="from" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
          </DatePicker>
          <Icon icon={faCalendar} iconClass="is-end" />
        </div>
      {/if}

      <div class={`${cssPrefix}control`}>
        <label for="from" class={`${cssPrefix}label`}>To</label>
      </div>

      {#if variant === 'Native'}
        <div class={`${cssPrefix}control`}>
          <slot name="to" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
        </div>
      {:else}
        <div class={`${cssPrefix}control is-date ${cssPrefix}date-picker has-icons-end`}>
          <DatePicker
            start={minDate[1]}
            end={maxDate[1]}
            bind:selected={selected[1]}
            format={pickerFormat}
            bind:dateChosen={$delegate[1].success}
            bind:formattedSelected={$delegate[1].iso}
            on:open={() => element.onEvent(new Event('focus'))}
            on:close={() => element.onEvent(new Event('blur'))}
            on:change={() => tick().then(() => element.onEvent(new Event('change')))}
          >
            <slot name="to" inputClass={$element.error ? `${cssPrefix}input has-error` : `${cssPrefix}input`} />
          </DatePicker>
          <Icon icon={faCalendar} iconClass="is-end" />
        </div>
      {/if}
    </div>
  </div>

  <div class={`${cssPrefix}form-info`} class:has-info={$element.info}>
    {#if $element.info}
      <div class={`${cssPrefix}message`}>
        <p id="${id[0]}-description">{$element.info}</p>
      </div>
    {/if}
  </div>

  {#if $element.error}
    <div class={`${cssPrefix}form-error`}>
      <div class={`${cssPrefix}message is-status-error`}>
        <p id="${id[0]}-error">{$element.error}</p>
      </div>
    </div>
  {/if}
</div>
